export class Settings {
  
  // è importante che TUTTI i valori abbiano un default

  ecommerce_attivo: boolean = false;


}
